export enum ENotificationType {
    success = 'success',
    warning = "warning",
    info = "info",
    error = 'error'
}
